import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface excelRevenueState {
  totalRecords: number | null;
  data: [] | null | any;
  totalPages: number | null;
  currentPage: number | null;
}

const initialState: excelRevenueState = {
  totalRecords: null,
  data: null,
  totalPages: null,
  currentPage: null,
};

export const excelRevenueSlice = createSlice({
  name: 'excelRevenue',
  initialState,
  reducers: {
    setExcel: (state: any, action: any) => {
      state.data = action.payload.data;
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;
      state.totalRecords = action.payload.totalRecords;
    },
    addNewExcel: (state: any, action: any) => {
      state.data = [action.payload.data, ...state.data];
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

export const { setExcel, addNewExcel, reset } = excelRevenueSlice.actions;
export const getExecelRevenue = (state: RootState) => state.excelRevenue.data;
export const addExecelRevenue = (state: RootState) => state.excelRevenue.data;
export const getExecelRevenueTotalRecord = (state: RootState) => state.excelRevenue.totalRecords;

export default excelRevenueSlice.reducer;
